export default __webpack_public_path__ + "static/media/header-anthe-2022.b9e140b4.png";